import { Box } from '@mui/material'

import React from 'react'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import BottomNavigation from '../components/BottomNavigation'
import { bottomMenus } from '../constants/bottomNavigation'

const MainLayouts = () => {
  const location = useLocation()
  const navigate = useNavigate()

  const getName = location.pathname.split('/')[1]
  return (
    <Box height={'100%'}>
      <Box pb="80px" height={'100%'}>
        <Outlet />
      </Box>

      <BottomNavigation value={getName} onChange={(val) => navigate(val)} options={bottomMenus} />
    </Box>
  )
}

export default MainLayouts
